import { IMobileAppRootState } from "../../mobileAppCore/types/mobileAppState.t";
import { createSelector } from "reselect";

const moduleSelector = (state: IMobileAppRootState) => state.referral;

export const getReferralQrCodeSelector = (state: IMobileAppRootState) => state.referral.qrCode;

export const getReferralLinkSelector = createSelector(
    moduleSelector, state => state.referralLink,
);

export const getReferralQRCodeSelector = createSelector(
    getReferralQrCodeSelector, state => state.data,
);

export const getReferralsSelector = createSelector(
    moduleSelector, state => state.referrals,
);

export const getReferralsCountSelector = createSelector(
    moduleSelector, state => state.referrals.length,
);

export const getIsLoadingGetReferralsSelector = createSelector(
    moduleSelector, state => state.isLoadingReferrals,
);

export const getReferralsQueryParamsSelector = createSelector(moduleSelector, state => state.queryParamsReferrals);

export const getReferralSelector = createSelector(
    moduleSelector, state => state.referral,
);

export const getReferralReferrerReward = createSelector(
    moduleSelector, state => state.referrerReward,
);

export const getReferrerGiftRewardSelector = createSelector(moduleSelector, state => state.referrerGiftRewardValue);

export const getReferralNotifyReceivedRewardSelector = createSelector(moduleSelector, state => state.notifyReceivedReward);

export const getReferralWarningResetProgressSelector = createSelector(moduleSelector, state => state.warningResetProgress);

export const getRespawnTimerSelector = createSelector(moduleSelector, state => state.respawnTimer);